import { Flex, MultiSelect, Text } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { SelectedSubjectsList } from '@dealstack/frontend/shared/components/SelectedSubjectsList/SelectedSubjectsList.tsx';

interface Props {
	selectedPersonIds: string[];
	personOptions: { value: string; label: string }[];
	onChange: (personIds: string[]) => void;
}

export const PerformanceVestingAccessedFor = ({
	selectedPersonIds,
	personOptions,
	onChange,
}: Props) => {
	const tCommonUi = useTranslationCommonUi();

	const handleRemoveSubject = (personId: string) => {
		onChange(selectedPersonIds.filter((id) => id !== personId));
	};

	return (
		<div className="accessed-for-section">
			<Text fw={600} c="dark.8" mb="0.25rem">
				{tCommonUi('vesting_terms.performance.accessed_for_label')}
			</Text>
			<Flex direction="column" gap="xs">
				<MultiSelect
					data={personOptions}
					value={selectedPersonIds}
					onChange={onChange}
					searchable
					clearable
					placeholder={tCommonUi('vesting_terms.performance.accessed_for_placeholder')}
					leftSection={<Icon variant="search" size="lg" />}
					styles={{
						input: {
							paddingLeft: '1.5rem !important',
						},
					}}
				/>

				<SelectedSubjectsList
					selectedIds={selectedPersonIds}
					options={personOptions}
					onRemove={handleRemoveSubject}
				/>
			</Flex>
		</div>
	);
};
